import { Coord } from '../../jscaip/Coord';
import { RelativePlayer } from '../../jscaip/RelativePlayer';
import { GameStateWithTable } from '../../jscaip/state/GameStateWithTable';
export class TaflState extends GameStateWithTable {
    isCentralThrone(coord) {
        return coord.equals(this.getCentralThrone());
    }
    getCentralThrone() {
        const center = (this.getSize() - 1) / 2;
        return new Coord(center, center);
    }
    getRelativeOwner(player, coord) {
        const owner = this.getAbsoluteOwner(coord);
        let relativeOwner;
        if (owner.isNone()) {
            relativeOwner = RelativePlayer.NONE;
        }
        else if (player === owner) {
            relativeOwner = RelativePlayer.PLAYER;
        }
        else {
            relativeOwner = RelativePlayer.OPPONENT;
        }
        return relativeOwner;
    }
    getAbsoluteOwner(coord) {
        const piece = this.getPieceAt(coord);
        return piece.getOwner();
    }
    getSize() {
        return this.getHeight();
    }
    hasOwnerAt(coord, owner) {
        const optional = this.getOptionalPieceAt(coord);
        if (optional.isPresent()) {
            return optional.get().getOwner().equals(owner);
        }
        else {
            return false;
        }
    }
    isExternalThrone(coord) {
        return this.isCorner(coord);
    }
}
